import React from 'react'
import BrandedError from '../../components/BrandedError'
import PublicPageLayout from '../../components/PublicPageLayout'

const NotFoundPage = () => {
  return (
    <PublicPageLayout>
      <BrandedError
        status="404"
        title="404"
        subTitle="Oops! The academic page you are looking for has been moved or doesn't exist."
        redirect="/"
      />
    </PublicPageLayout>
  )
}

export default NotFoundPage
